<template>
  <div>
    <ChitActionsMenuBtn
      :use-full-btn="true"
      :disabled="loading"
      :state="state"
      @export-chit-pdf-pressed="emit('export-chit-pdf-pressed')"
    />
  </div>
</template>

<script setup lang="ts">
import type { ChitState } from '@/models/chit'
import ChitActionsMenuBtn from '../ChitActionsMenuBtn.vue'

interface Props {
  loading: boolean
  state: ChitState
}
defineProps<Props>()

interface Emit {
  (e: 'export-chit-pdf-pressed'): void
}
const emit = defineEmits<Emit>()
</script>
